import { Layout } from "antd";
import fabric from "./../fabric";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CanvasHeader from "../components/CanvasHeader";
import Slidebar from "../components/Tools/Slidebar";
import {initCenteringGuidelines,initAligningGuidelines} from "./GuidLines";
import {
  setCurrentCanvas,
  closeAllOpenMenus,
  setShapesDrawer,
  setTemplatesDrawer,
  setImagesDrawer,
  setClipArtDrawer,
  setEmojiDrawer,
} from "../slices/creatorSlice";
import ShapesDrawer from "../components/drawers/ShapesDrawer";
import TemplatesDrawer from "../components/drawers/TemplatesDrawer";
import ImagesDrawer from "../components/drawers/ImagesDrawer";
import ClipArtDrawer from "../components/drawers/ClipArtDrawer.jsx";
import {
  Copy,
  deleteObject,
  Paste,
} from "../CommonFunctions/PropertybarFunctions";
import EmojiDrawer from "../components/drawers/EmojiDrawer";
import "fabric-history";

// import { BindEvents } from "../CommonFunctions/BindEvents";
const { Content } = Layout;
export default function Create() {
  const canvasRef = useRef(null);
  const canvContRef = useRef(null);
  const [canvas, setCanvas] = useState(null);
  const dispatch = useDispatch();
  const _currentCanvasData = useSelector(
    (state) => state.creator.currentCanvasData
  );
  const shapesDrawerOpen = useSelector(
    (state) => state.creator.shapesDrawerOpen
  );
  const templatesDrawerOpen = useSelector(
    (state) => state.creator.templatesDrawerOpen
  );
  const imagesDrawerOpen = useSelector(
    (state) => state.creator.imagesDrawerOpen
  );
  const clipArtDrawerOpen = useSelector(
    (state) => state.creator.clipArtDrawerOpen
  );
  const emojiDrawerOpen = useSelector((state) => state.creator.emojiDrawerOpen);
  const _CanvasSize = useSelector((state) => state.creator.canvasSize);
  const [canvasSize, setCanvasSize] = useState(_CanvasSize);

  //this will making initial canvas using fabric.js afterwords the json data will load in it.
  const initCanvas = () => {
    //parentHeight is the height of the div that hold the canvas
    var parentHeight = document.getElementById("canvasContainer").clientHeight;

    return new fabric.Canvas(canvasRef.current, {
      height: parentHeight,
      width: parentHeight,
      backgroundColor: "#e8ebef",
      perPixelTargetFind: true,
      targetFindTolerance: 4,
    });
  };

  //set initial canvas
  useEffect(() => {
    (async () => {
      setCanvas(initCanvas());
      /*this method dispach and set the currentCanvasData from the first element 
      json data of the canvases array by default store in Redux store.*/
      dispatch(setCurrentCanvas(0));
    })();
  }, []);

  // Added events to close all the dropdown menus when clicked outside
  useEffect(() => {
    const listener = (event) => {
      dispatch(closeAllOpenMenus());
    };
    canvContRef.current.addEventListener("mousedown", listener);
    canvContRef.current.addEventListener("touchstart", listener);
    return () => {
      canvContRef.current.removeEventListener("mousedown", listener);
      canvContRef.current.removeEventListener("touchstart", listener);
    };
  }, []);

  //when current canvas change canvas will update
  useEffect(() => {
    if (_currentCanvasData) {
      var json = JSON.stringify(_currentCanvasData);
      canvas.clear();
      canvas.loadFromJSON(json, canvas.renderAll.bind(canvas));
      canvas.renderAll();
      // BindEvents(canvas);
      window.addEventListener("keydown", (e) => {
        if (e.keyCode === 90 && (e.ctrlKey || e.metaKey)) {
          canvas.undo();
        }
        if (e.keyCode === 89 && (e.ctrlKey || e.metaKey)) {
          canvas.redo();
        }
        if (e.key === "Delete" || e.keyCode === 46) {
          deleteObject(canvas);
        }
        if (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) {
          Copy(canvas);
        }
        if (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) {
          Paste(canvas);
        }
      });
    }
    return () => {
      window.removeEventListener("keydown", (e) => {
        if (e.key === "Delete" || e.keyCode === 46) {
          deleteObject(canvas);
        }
      });
    };
  }, [_currentCanvasData]);

  useEffect(() => {
    setCanvasSize(_CanvasSize);
    if (canvas) {
      canvas.setHeight(_CanvasSize.height);
      canvas.setWidth(_CanvasSize.width);
      canvas.renderAll();
    }
  }, [_CanvasSize]);

  //GuidLines
  if (canvas) {
    initCenteringGuidelines(canvas);
    initAligningGuidelines(canvas);
  }
  return (
    <React.Fragment>
      <Layout
        className="h-auto bg-red-50 max-h-max"
        style={{ background: "rgb(254 242 242)" }}
      >
        {/* top-header */}
        <CanvasHeader canvas={canvas} />

        <Layout className="max-h-max" style={{ background: "transparent" }}>
          <ShapesDrawer canvas={canvas} />
          <Content ref={canvContRef}>
            <TemplatesDrawer canvas={canvas} />
            <ImagesDrawer canvas={canvas} />
            <ClipArtDrawer canvas={canvas} />
            <EmojiDrawer canvas={canvas} />
            <div className="flex justify-center items-start">
              <div className="flex flex-col justify-start absolute left-0">
                {/* Button to open the drawer for shapes */}
                <button
                  onClick={() => {
                    dispatch(setShapesDrawer(!shapesDrawerOpen));
                  }}
                  className="border-2 rounded-r-full px-3 py-1 bg-[#1890ff] text-[#ffffff]"
                >
                  Shapes
                </button>

                {/* Button to open the drawer for templates */}
                <button
                  onClick={() => {
                    dispatch(setTemplatesDrawer(!templatesDrawerOpen));
                  }}
                  className=" border-2 rounded-r-full px-3 py-1 bg-[#1890ff] text-[#ffffff]"
                >
                  Templates
                </button>
                <button
                  onClick={() => {
                    dispatch(setImagesDrawer(!imagesDrawerOpen));
                  }}
                  className=" border-2 rounded-r-full px-3 py-1 bg-[#1890ff] text-[#ffffff]"
                >
                  Images
                </button>
                <button
                  onClick={() => {
                    dispatch(setClipArtDrawer(!clipArtDrawerOpen));
                  }}
                  className=" border-2 rounded-r-full px-3 py-1 bg-[#1890ff] text-[#ffffff]"
                >
                  ClipArts
                </button>
                <button
                  onClick={() => {
                    dispatch(setEmojiDrawer(!emojiDrawerOpen));
                  }}
                  className=" border-2 rounded-r-full px-3 py-1 bg-[#1890ff] text-[#ffffff]"
                >
                  Emojis
                </button>
              </div>

              <div
                className={`bg-transparent mb-3 relative mx-10`}
                id="canvasContainer"
                style={{
                  transform: `scale(${canvasSize.scale})`,
                  height: `${canvasSize.height}px`,
                  width: `${canvasSize.width}px`,
                  marginTop: `${canvasSize.marginTop}px`,
                }}
              >
                {/* main-canvas */}
                <canvas
                  ref={canvasRef}
                  style={{
                    boxShadow: "0px 5px 15px 0px #0000001a",
                  }}
                ></canvas>
              </div>
            </div>
          </Content>

          {/* bottom-slidebar */}
          <Slidebar canvas={canvas} />
        </Layout>
      </Layout>
    </React.Fragment>
  );
}
